import { useParams } from "react-router-dom";
import { SmsCampaignContextForm } from "../../../../../components/secondaryComponents/SmsCampaign";
import { useGetSmsCampaignDetails } from "../../../../../hooks/api/queries/useMarketing";
import secondaryComponents from "../../../../../components/secondaryComponents";

const SmsCampaignContext = () => {
  const { id } = useParams();
  const { data: smsCampaign, isLoading } = useGetSmsCampaignDetails({ id });

  return (
    <section>
      <secondaryComponents.LoaderHelper
        classNames={"mt-5"}
        isLoading={isLoading}
      >
        <SmsCampaignContextForm smsCampaign={smsCampaign} isEditMode={true} />
      </secondaryComponents.LoaderHelper>
    </section>
  );
};

export default SmsCampaignContext;
